import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoTerapias from "./CreaEquipos/CreaEquipoTerapias";
import Cookies from "universal-cookie";
import DequipoTerapia from "../../EliminaEquipos/DequipoTerapia";
function EquipoTerapias(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      // url: 'https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTerapias'
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTerapiasPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1]; // Encuentra la parte después del '#' que es la ruta

  return (
    <div className="test">
      <div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    3.3. Equipo Primario de Mejoramiento de Terapias (Física,
                    Ocupacional, Lenguaje y Respiratoria)
                  </h6>
                </div>
                <div class="card-body">
                  {cookies.get("tipo_Usuario") == 2 &&
                  nombreRuta == "ProcesoAutoevaluacion" ? (
                    <CreaEquipoTerapias idSolicitud={props.idSolicitud} />
                  ) : (
                    <h></h>
                  )}
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>nombre </th>
                          <th>servicio</th>
                          <th>cargo</th>
                          <th>Lider</th>
                          {nombreRuta == "ProcesoAutoevaluacion" ? (
                            <th>Elimina</th>
                          ) : (
                            <h></h>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => {
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.nombre}</td>
                              <td>{item.servicio}</td>
                              <td>{item.cargo}</td>
                              <td>{item.lider}</td>
                              {nombreRuta == "ProcesoAutoevaluacion" ? (
                                <td>
                                  <DequipoTerapia id={item.id} />
                                </td>
                              ) : (
                                <j></j>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoTerapias;
